import React from 'react';
import { Typography } from '@mui/material';
import { YardReciptData } from '@Src/_basic/object/YardReceiptsType';

interface Props {
  row: YardReciptData;
}
export default function SpecificationNameColumnFormatter(props: Props) {
  const { row } = props;
  return (
    <>
      {row.specification1Name ? (
        <Typography variant="inherit">{row.specification1Name}</Typography>
      ) : (
        <Typography variant="inherit">&nbsp;</Typography>
      )}
      {row.specification2Name ? (
        <Typography variant="inherit">{row.specification2Name}</Typography>
      ) : (
        <Typography variant="inherit">&nbsp;</Typography>
      )}
      {row.specification3Name ? (
        <Typography variant="inherit">{row.specification3Name}</Typography>
      ) : (
        <Typography variant="inherit">&nbsp;</Typography>
      )}
    </>
  );
}
